import axios from 'axios';
//将图片转换为Base64
function getImgToBase64(url, callback) {
  var canvas = document.createElement('canvas'),
    ctx = canvas.getContext('2d'),
    img = new Image;
    // img.crossOrigin = 'Anonymous';
    img.setAttribute('crossOrigin', 'anonymous')

  img.onload = function () {
    console.log('kaishi')
    canvas.height = img.height;
    canvas.width = img.width;
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL('image/png');
    var file = callback(dataURL);
    canvas = null;
    return file;
  };
  // img.src = url;
  img.src = url + '?time=' + new Date().valueOf();
}
//将base64转换为文件对象
function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  //转换成file对象
  return new File([u8arr], filename, {
    type: mime
  });
  //转换成成blob对象
  //return new Blob([u8arr],{type:mime});
}
//将图片转换为base64,再将base64转换成file对象
function imgToFile(url, filename = 'filename') {
  return getImgToBase64(url, data => {
    var myFile = dataURLtoFile(data, filename);
    console.log(myFile);
    return myFile;
  })
}

// 导出Excel公用方法
function exportMethod(data) {
  // 创建实例时设置配置的默认值
  var instance = axios.create();
  // 在实例已创建后修改默认值
  instance.defaults.headers.post['Content-Type'] = 'application/octet-stream;charset=UTF-8';
  instance({
    method: data.method,
    url: `${data.url}${data.params ? '?' + data.params : ''}`,
    responseType: 'blob',
  }).then((res) => {
    const link = document.createElement('a')
    let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)

    // link.download = res.headers['content-disposition'] //下载后文件名
    link.download = data.fileName //下载的文件名
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }).catch(error => {
    this.$Notice.error({
      title: '错误',
      desc: '网络连接错误'
    })
    console.log(error)
  })
}

export default {
  getImgToBase64,
  dataURLtoFile,
  exportMethod
}



// WEBPACK FOOTER //
// ./src/util/index.js